export const PRIORITIES: any = [
  {
    title: "...",
    icon: "eye-off-2-outline",
    value: 0,
    status: "info",
  },
  { title: "Bình thường", icon: "eye-outline", value: 1, status: "primary" },
  {
    title: "Quan trọng",
    icon: "alert-circle-outline",
    value: 2,
    status: "warning",
  },
  { title: "Khẩn cấp", icon: "flash-outline", value: 3, status: "danger" },
];

export const STATUS: any = [
  {
    id: 0,
    name: "Chờ...",
    title: "Chờ...",
    text: "pending",
    value: 0,
    status: "basic",
  },
  {
    id: 1,
    name: "Chuẩn bị",
    title: "Chuẩn bị",
    text: "todo",
    value: 1,
    status: "primary",
  },
  {
    id: 2,
    name: "Đang làm",
    title: "Đang làm",
    text: "progress",
    value: 2,
    status: "info",
  },
  {
    id: 3,
    name: "Xem xét",
    title: "Xem xét",
    text: "review",
    value: 3,
    status: "warning",
  },
  {
    id: 4,
    name: "Hoàn thành",
    title: "Hoàn thành",
    text: "done",
    value: 4,
    status: "success",
  },
  {
    id: 5,
    name: "Từ chối",
    title: "Từ chối",
    text: "reject",
    value: 5,
    status: "danger",
  },
];

export const OBJECT_TYPE: any = [
  {
    title: "Khách hàng",
    value: "customer",
    status: "info",
  },
  { title: "Nhà cung cấp", value: "supplier", status: "primary" },
  {
    title: "Nội bộ",
    value: "employee",
    status: "warning",
  },
];

export const FINANCE_TYPE: any = [
  {
    title: "Khách hàng",
    value: "receipt",
    status: "info",
  },
  { title: "Nhà cung cấp", value: "purchase", status: "primary" },
  {
    title: "Nội bộ",
    value: "employee",
    status: "warning",
  },
];
